export default {
      id: "i-aton-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/sprite.svg#i-aton",
      toString: function () {
        return this.url;
      }
    }